import { useQuery } from '@tanstack/react-query';

import { fetchAdminUser } from '@/services/admin';

import type { IAdminUser } from '@/types/user';

export function useAdminUser(userId: string | undefined) {
  const { data, isLoading, error, refetch } = useQuery<IAdminUser, Error>({
    queryKey: ['adminUser', userId],
    queryFn: () => (userId ? fetchAdminUser(userId) : Promise.reject(new Error('No userId'))),
    enabled: !!userId,
  });

  const errorStatus =
    error && 'response' in error
      ? ((error as { response?: { status?: number } }).response?.status ?? null)
      : null;

  return {
    data: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
    errorStatus,
    refetch,
  };
}
